import React, { Component } from "react";
import api from "../../api/promo-api";
import { Redirect } from "react-router-dom";
import Toast from "../../utils/toast";
import moment from "moment";

class PromoList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toast: {
        isShow: false,
        alertType: null,
        message: null,
      },
      promos: [],
      isLoading: false,
      redirect: null,
    };
  }

  componentDidMount = () => {
    this.getAllPromos();
  };

  getAllPromos = () => {
    this.setState({ isLoading: true });

    api
      .getAllPromos()
      .then((r) => {
        this.setState({
          promos: r.data,
          isLoading: false,
        });
      })
      .catch((error) => {
        this.setState({ isLoading: false });
        let message = "";
        if (error.response) {
          message = `${error.response.status} ${
            error.response.statusText
          }\n${JSON.stringify(error.response.data)}`;
          // Request made and server responded
          console.log(error.response);
        } else if (error.request) {
          message = "no response";
          console.log(error.request);
        } else {
          message = `request failed: ${error.message}`;
          console.log("Error", error.message);
          if (error.message === "Refresh token is outdated") {
            this.setState({
              redirect: "/login",
            });
          }
        }
        this.showMessage(message, "danger");
      });
  };

  onAddClick = (e) => {
    e.preventDefault();

    this.setState({
      redirect: `/promo/add`,
    });
  };

  onEditClick = (e) => {
    e.preventDefault();
    const code = e.currentTarget.value;

    this.setState({
      redirect: `/promo/edit/${code}`,
    });
  };

  onDeleteClick = (e) => {
    e.preventDefault();
    const code = e.currentTarget.value;
    if (window.confirm(`Точно удалить промокод? ${code}`)) {
      this.setState({ isLoading: true });

      api
        .deletePromoByCode(code)
        .then(() => {
          this.getAllPromos();
        })
        .catch((error) => {
          this.setState({ isLoading: false });
          let message = "";
          if (error.response) {
            message = `${error.response.status} ${
              error.response.statusText
            }\n${JSON.stringify(error.response.data)}`;
            // Request made and server responded
            console.log(error.response);
          } else if (error.request) {
            message = "no response";
            console.log(error.request);
          } else {
            message = `request failed: ${error.message}`;
            console.log("Error", error.message);
            if (error.message === "Refresh token is outdated") {
              this.setState({
                redirect: "/login",
              });
            }
          }
          this.showMessage(message, "danger");
        });
    }
  };

  onCloseToast = () => {
    let toast = this.state.toast;
    this.setState({
      toast: {
        ...toast,
        isShow: false,
      },
    });
  };

  showMessage = (e, type = "success") => {
    let toast = this.state.toast;
    this.setState({
      toast: {
        ...toast,
        isShow: true,
        alertType: type,
        message: e.toString(),
      },
    });
  };

  onLogoutClick = () => {
    this.setState({
      redirect: `/logout`,
    });
  };

  render() {
    if (this.state.redirect) {
      return (
        <Redirect
          push
          to={{
            pathname: this.state.redirect,
            state: { from: "/promo" },
          }}
        />
      );
    }

    let showTable = true;
    if (!this.state.promos.length) {
      showTable = false;
    }

    const formatDate = (date) => {
      var m = moment.utc(date).local();
      return m.format("DD.MM.YYYY HH:mm");
    };

    return (
      <div class="container">
        <Toast
          isShow={this.state.toast.isShow}
          onClose={this.onCloseToast}
          message={this.state.toast.message}
          alertType={this.state.toast.alertType}
        ></Toast>
        <h3>Промокоды</h3>
        <button
          class="btn u-btn-primary g-font-size-13 g-py-10"
          onClick={this.onAddClick}
        >
          Создать
        </button>
        <button
          class="btn u-btn-primary g-font-size-13 g-py-10 pull-right"
          onClick={this.onLogoutClick}
        >
          Выйти
        </button>
        {showTable && (
          <div class="table-responsive mt-3">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Код</th>
                  <th>Скидка</th>
                  <th>Активный до</th>
                  <th>Описание</th>
                  <th></th>
                </tr>
              </thead>

              <tbody>
                {this.state.promos.map((s, index) => {
                  return (
                    <tr key={"promo_" + index}>
                      <td>{s.code}</td>
                      <td>{s.discount}</td>
                      <td>{formatDate(s.expirationDate)}</td>
                      <td>{s.description}</td>

                      <td>
                        <button
                          type="button"
                          class="btn btn-default"
                          value={s.code}
                          onClick={this.onEditClick}
                        >
                          <i
                            class="fa fa-pencil-square-o"
                            aria-hidden="true"
                          ></i>
                        </button>
                        <button
                          type="button"
                          class="btn btn-default"
                          value={s.code}
                          onClick={this.onDeleteClick}
                        >
                          <i class="fa fa-trash-o" aria-hidden="true"></i>
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  }
}

export default PromoList;
